import { c as _c } from "react/compiler-runtime";
import { stopLoggingBootErrors } from '@onefootprint/core';
import { Logger } from '@onefootprint/idv';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import Script from 'next/script';
import Providers from '../components/providers';
import { GOOGLE_MAPS_SRC } from '../config/constants';
import '../styles/globals.css';

// Don't enable logger replay until we know we are in a live onboarding
Logger.init('bifrost', /* deferSessionRecord */true);
stopLoggingBootErrors();
const App = t0 => {
  const $ = _c(10);
  const {
    Component,
    pageProps
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Head><meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" /></Head>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Component || $[2] !== pageProps) {
    t2 = <Component {...pageProps} />;
    $[1] = Component;
    $[2] = pageProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== pageProps || $[5] !== t2) {
    t3 = <Providers pageProps={pageProps}>{t2}</Providers>;
    $[4] = pageProps;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = GOOGLE_MAPS_SRC ? <Script src={GOOGLE_MAPS_SRC} async={true} strategy="lazyOnload" /> : null;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <>{t1}{t3}{t4}</>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default App;